const earlyDecisionNames = {
    'decision': 'Early Decision',
    'decision2': 'Early Decision 2',
  }
  
  export default earlyDecisionNames
  